import React from 'react';
import { Link } from 'react-router-dom';
import { errorPages } from '@/data/content';

const PlateIllustration: React.FC = () => (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" aria-hidden="true" className="text-app-primary/40">
        <circle cx="48" cy="48" r="40" stroke="currentColor" strokeWidth="3" strokeDasharray="6 4" />
        <circle cx="48" cy="48" r="28" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <line x1="36" y1="34" x2="36" y2="48" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="33" y1="34" x2="33" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="36" y1="34" x2="36" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="39" y1="34" x2="39" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="60" y1="34" x2="60" y2="62" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M60 34 Q64 38 63 44 L60 46" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
        <text
            x="48"
            y="54"
            textAnchor="middle"
            fontSize="18"
            fontWeight="800"
            fill="currentColor"
            fontFamily="sans-serif"
        >
            ?
        </text>
    </svg>
);

const NotFound: React.FC = () => (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
        <div className="flex flex-col items-center text-center max-w-sm animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="mb-6">
                <PlateIllustration />
            </div>
            <h1 className="text-3xl font-black text-app-text dark:text-white mb-2">{errorPages.not_found_title}</h1>
            <p className="text-gray-500 dark:text-gray-400 text-sm mb-8">{errorPages.not_found_description}</p>
            <div className="flex flex-wrap items-center justify-center gap-3">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 py-2.5 px-5 bg-app-primary hover:bg-orange-600 text-white font-bold rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 text-sm"
                >
                    ← {errorPages.back_home}
                </Link>
                <Link
                    to="/menu"
                    className="inline-flex items-center gap-2 py-2.5 px-5 border-2 border-app-primary text-app-primary font-bold rounded-xl hover:bg-app-primary hover:text-white transition-all duration-200 text-sm"
                >
                    {errorPages.view_menu}
                </Link>
            </div>
        </div>
    </div>
);

export default NotFound;
